const INITIAL_STATE = {
  productsList: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_PRODUCTS': {
      return { ...state, productsList: action.products };
    }
    default:
      return state;
  }
};
